import { TranslateService } from '@ngx-translate/core';
import { UnitType } from '@iss/libs/graphql';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { BaseEnumTranslationPipe } from './base-enum-translation.pipe';

@Pipe({ name: 'unitType', pure: false, standalone: true })
export class UnitTypePipe extends BaseEnumTranslationPipe<UnitType> implements PipeTransform {
  protected readonly translationPrefix = 'iss-mc.enum.unit-type';

  public constructor(
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translateService, changeDetectorRef);
  }
}
